export const SkeletonBanner = () => (
  <div className="w-full aspect-[2.2/1] md:aspect-[3/1] bg-muted rounded-2xl animate-pulse-soft" />
);

export const SkeletonCategory = () => (
  <div className="flex flex-col items-center gap-2.5">
    <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-muted animate-pulse-soft border-2 border-transparent" />
    <div className="w-14 h-3.5 bg-muted rounded animate-pulse-soft" />
  </div>
);

export const SkeletonProduct = () => (
  <div className="bg-card rounded-[32px] p-4 shadow-sm border border-border">
    <div className="flex gap-4">
      <div className="flex-1 space-y-3">
        <div className="w-16 h-4 bg-muted rounded animate-pulse-soft" />
        <div className="w-3/4 h-5 bg-muted rounded animate-pulse-soft" />
        <div className="w-1/3 h-4 bg-muted rounded animate-pulse-soft" />
        <div className="w-full h-3 bg-muted rounded animate-pulse-soft" />
      </div>
      <div className="w-28 h-28 md:w-32 md:h-32 rounded-2xl bg-muted animate-pulse-soft" />
    </div>
  </div>
);

export const SkeletonCategoryAccordion = () => (
  <div className="bg-card rounded-lg p-4 border border-border flex items-center gap-4">
    <div className="w-14 h-14 rounded-full bg-muted animate-pulse-soft" />
    <div className="w-32 h-5 bg-muted rounded animate-pulse-soft" />
  </div>
);

export const HomeSkeleton = () => (
  <div className="space-y-12 pb-8 animate-in fade-in duration-500">
    <SkeletonBanner />
    <div className="space-y-5">
      <div className="flex gap-5 md:gap-8 justify-center flex-wrap">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonCategory key={i} />
        ))}
      </div>
    </div>
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonProduct key={i} />
        ))}
      </div>
    </div>
  </div>
);
